import React, {useState} from 'react';
import './App.css';
import InputForm from './components/InputForm';
import Diagnosis from './components/Diagnosis';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";

function App() {
    const [data, setData] = useState('')
    const sendDataToParent = (index) => { // the callback. Use a better name
        setData(index);
    };

    return (
        <div className="App">
            <header className="App-header">
                <Router basename={process.env.PUBLIC_URL}>
                    <Routes>
                        <Route path="/" element={<InputForm sendDataToParent={sendDataToParent}/>}>
                        </Route>
                        <Route path="/diagnosis" element={<Diagnosis data={data} sendDataToParent={sendDataToParent}/>}>
                        </Route>
                    </Routes>
                </Router>
            </header>
        </div>
    );
}

export default App;
